import axios from "axios";
import assert from "assert";
import { Definer } from "../lib/Definer";
import { serverApi } from "../lib/config";
import {
  BoArticle,
  BoArticleInput,
  SearchArticlesObj,
  SearchMemberArticlesObj,
} from "../types/boArticle";
import { Review, ReviewCreateData } from "../types/review";
import { Member } from "../types/user";

class CommunityApiService {
  private readonly path: string;
  constructor() {
    this.path = serverApi;
  }

  public async createArticlle(data: BoArticleInput) {
    try {
      const result = await axios.post(this.path + "/community/create", data, {
        withCredentials: true,
      });
      assert.ok(result?.data, Definer.general_err1);
      assert.ok(result?.data.state !== "fail", result?.data?.message);
      console.log("state", result.data.data);

      const article: BoArticle = result.data.data;
      return article;
    } catch (err: any) {
      console.log(`ERROR ::: getTargetArticles", ${err.message}`);
      throw err;
    }
  }

  public async uploadImageToServer(image: any) {
    try {
      let formData = new FormData();
      formData.append("community_image", image);
      const result = await axios(`${this.path}/community/image`, {
        method: "POST",
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      assert.ok(result?.data, Definer.general_err1);
      assert.ok(result?.data.state !== "fail", result?.data?.message);
      console.log("state", result.data.data);
      const image_name: string = result.data.data;
      return image_name;
    } catch (err: any) {
      console.log(`ERROR ::: getTargetArticles", ${err.message}`);
      throw err;
    }
  }

  public async getTargetArticles(data: SearchArticlesObj) {
    try {
      let url = `/community/target?bo_id=${data.bo_id}&page=${data.page}&limit=${data.limit}`;
      if (data.order) url += `&order=${data.order}`;
      const result = await axios.get(this.path + url, {
        withCredentials: true,
      });
      assert.ok(result?.data, Definer.general_err1);
      assert.ok(result?.data.state !== "fail", result?.data?.message);
      console.log("state", result.data.data);
      const articles: BoArticle[] = result.data.data;
      return articles;
    } catch (err: any) {
      console.log(`ERROR ::: getTargetArticles", ${err.message}`);
      throw err;
    }
  }

  public async getMemberCommunityArticle(data: SearchMemberArticlesObj) {
    try {
      let url = `/community/articles?mb_id=${data.mb_id}&page=${data.page}&limit=${data.limit}`;
      const result = await axios.get(this.path + url, {
        withCredentials: true,
      });
      assert.ok(result?.data, Definer.general_err1);
      assert.ok(result?.data.state !== "fail", result?.data?.message);
      console.log("state", result.data.data);
      const articles: BoArticle[] = result.data.data;
      return articles;
    } catch (err: any) {
      console.log(`ERROR ::: getMemberCommunityArticle", ${err.message}`);
      throw err;
    }
  }
  public async getChosenArticle(art_id: string) {
    try {
      let url = `/community/single-article/${art_id}`;
      const result = await axios.get(this.path + url, {
        withCredentials: true,
      });
      assert.ok(result?.data, Definer.general_err1);
      assert.ok(result?.data.state !== "fail", result?.data?.message);
      console.log("state", result.data.data);
      const article: BoArticle = result.data.data;
      return article;
    } catch (err: any) {
      console.log(`ERROR ::: getChosenArticle", ${err.message}`);
      throw err;
    }
  }
  async createReview(data: ReviewCreateData): Promise<Review> {
    try {
      const url = `${serverApi}/review/createReview`;
      const result = await axios.post(url, data, { withCredentials: true });
      console.log("createReview state::", result.data.state);
      assert.ok(result?.data, Definer.general_err1);
      assert.ok(result?.data.state !== "fail", result?.data?.message);
      const review: Review = result.data.data;
      return review;
    } catch (err) {
      throw err;
    }
  }

  async getProductReviews(product_id: string): Promise<Review[]> {
    try {
      const url = `${serverApi}/review/getReviews/${product_id}`;
      const result = await axios.get(url, { withCredentials: true });
      assert.ok(result?.data, Definer.general_err1);
      assert.ok(result?.data.state !== "fail", result?.data?.message);
      console.log(`getProductReviews state, ${result.data.state}`);
      const reviews: Review[] = result.data.data;
      return reviews;
    } catch (err) {
      throw err;
    }
  }

 
}

export default CommunityApiService;
